import { uniqueId } from 'lodash'
import React, { type CSSProperties } from 'react'

import type { FilterOption } from '../types'

type FilterOptionButtonsProps<T> = {
  options: FilterOption<T>[]
  handleClick: (selectedIndex: number) => void
  selectedIndex: number
}

export function FilterOptionButtons<T>({ options, handleClick, selectedIndex }: FilterOptionButtonsProps<T>) {
  return (
    <div style={styles.container}>
      {options.map((option, i) => {
        const key = uniqueId()
        return (
          <button
            key={key}
            type='button'
            style={{
              ...styles.button,
              //border: i === selectedIndex ? `1px solid var(--theme-color-2)` : `none`,
              backgroundColor: i === selectedIndex ? `var(--theme-color-2-trans)` : `transparent`,
              //color: i === selectedIndex ? 'var(--theme-color-2)' : '',
              color: i === selectedIndex ? 'var(--theme-color-2)' : '',
            }}
            onClick={() => handleClick(i)}
          >
            {option.text}
          </button>
        )
      })}
    </div>
  )
}

const styles: Record<string, CSSProperties> = {
  button: {
    border: 'none',
    padding: '12px 16px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
    background: 'transparent',
    textAlign: 'left',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '250px',
    overflowY: 'auto',
    backgroundColor: 'white',
    width: 'auto',
  },
}
